import Navbar from "./Navbar";

function Footer() {
  return (
    <>
      <div classNames="footer">
        
            <Navbar />

      </div>
    </>
  );
}

export default Footer;
